import type { TFunction } from 'i18next';
import type { SearchItem } from './types';

/** Second line of a search suggestion. */
export function describeItem(t: TFunction<'search'>, { details }: SearchItem): string {
  switch (details.kind) {
    case 'coordinates':
      return t(`format.${details.format}`);
    case 'plusCode':
      return details.near ? t('plusCodeNear', { place: details.near }) : t('plusCodeNearCentre');
    case 'place':
      return details.text;
  }
}
